import { CheckoutState } from '../../state';
import { isNativeApp } from '../app';
import {
    getIsNosSourceOfTruth,
    getShouldAcceptOffline,
    isSalesClient,
} from '../event';
import {
    hasRequiredCannedQuestions,
    hasRequiredCustomQuestions,
} from '../expressCheckoutConditions';

export const arePostCheckoutMandatoryQuestionsFlowRulesForExpressCheckoutMet = (
    state: CheckoutState,
) =>
    !isNativeApp(state) &&
    hasRequiredCannedQuestions(state) &&
    !hasRequiredCustomQuestions(state) &&
    getIsNosSourceOfTruth(state) &&
    !isSalesClient(state) &&
    !getShouldAcceptOffline(state);
